import styled from "styled-components";
import { em, rem } from "convert-to-ems";

export const CenteredElement = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${props => props.justifyContent};
`;

export const TitleStyled = styled.div`
  h1 {
    width: 100%;
    color: ${props => props.theme.backgroundColor};
    ${props => (props.marginLeft ? `margin-left: ${props.marginLeft}` : "")};
    ${props => (props.marginBottom ? `margin-bottom: ${props.marginBottom}` : "")};

    padding-top: ${props => rem(props.paddingTop)};

    @media (${props => props.theme.breakpoints.mobile}) {
      margin-left: ${props => rem(props.marginLeft)};
    }

    @media (${props => props.theme.breakpoints.tinyMobile}) {
      font-size: ${props => props.theme.tinyFont};
    }
  }

  p {
    width: 100%;
    color: ${props => props.textFontColor};
    font-weight: ${props => props.textFontWeight};
    font-family: ${props => props.theme.baseFontFamily};
    font-size: ${props => em(props.textFontSize)};
    line-height: ${props => rem(props.textLineHeight)};
    ${props => (props.marginLeft ? `margin-left: ${props.marginLeft}` : "")};
    ${props => (props.marginTop ? `margin-top: ${props.marginTop}` : "")};
    ${props => (props.marginRight ? `margin-right: ${props.marginRight}` : "")};
    ${props => (props.marginBottom ? `margin-bottom: ${props.marginBottom}` : "")};

    @media (${props => props.theme.breakpoints.mobile}) {
      font-size: ${props => em(props.textFontSizeMobile)};
      line-height: ${props => rem(props.textLineHeightMobile)};
      ${props => (props.marginLeftMobile ? `margin-left: ${props.marginLeftMobile}` : "")};
      ${props => (props.marginTopMobile ? `margin-top: ${props.marginTopMobile}` : "")};
      ${props => (props.marginRightMobile ? `margin-right: ${props.marginRightMobile}` : "")};
      ${props => (props.marginBottomMobile ? `margin-bottom: ${props.marginBottomMobile}` : "")};
    }
  }

  span {
    width: 100%;
    font-size: ${em(12)};
    font-family: "Roboto";
    color: gray;
    ${props => (props.marginLeft ? `margin-left: ${props.marginLeft}` : "")};
    ${props => (props.marginTop ? `margin-top: ${props.marginTop}` : "")};
    ${props => (props.marginRight ? `margin-right: ${props.marginRight}` : "")};
    ${props => (props.marginBottom ? `margin-bottom: ${props.marginBottom}` : "")};

    @media (${props => props.theme.breakpoints.mobile}) {
      font-size: ${em(10.5)};
    }
  }
`;
